<template>
	<b-modal ref="modal" title="Edit item" :busy="loading>0">
		<b-form @submit.stop.prevent="save(); return false;" id="userChatterEditForm" v-if="curChatter && curChatter.settings">
			<b-form-row class="mb-3">
				<b-col>
					<b-form-group label="Service">
						<b-avatar :src="curChatter.service_icon_url" size="1rem"/>
						{{curChatter.service_name}}
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Chatter">
						<b-avatar :src="curChatter.avatar" size="1rem"></b-avatar>
						{{curChatter.display_name||curChatter.chatter_token}}
					</b-form-group>
				</b-col>
			</b-form-row>
			<b-form-group>
				<template slot="label">
					<b-form-checkbox switch v-model="curChatter.tts_status" value="muted" unchecked-value="enabled" class="float-right" @input="voiceSuggestions = []">Mute TTS</b-form-checkbox>
					Voice
				</template>
				<VueTypeaheadBootstrap
					v-model="curChatter.voice_name"
					:data="voiceSuggestions"
					:serializer="item => `${item.name}`"
					@hit="setVoice($event)"
					placeholder="Search voices..."
					@input="voiceSearch"
					disable-sort
					show-all-results
					:disabled="curChatter.tts_status == 'muted'"
				>
					<template slot="append">
						<b-input-group-text>
							<b-icon icon="search" />
						</b-input-group-text>
					</template>
					<template slot="suggestion" slot-scope="{ data }">
						{{data.description||data.name}}<br />
						<small>{{data.language}}{{data.age?` ${data.age}`:''}}{{data.sex?` ${data.sex}`:''}}, {{data.provider}}, {{data.type}}</small><br />
						<code v-if="data.selector">!voice {{data.selector}}</code>
					</template>
				</VueTypeaheadBootstrap>
			</b-form-group>
			<b-form-row>
				<b-col>
					<b-form-group label="Pitch">
						<template slot="label"><div class="float-right">{{(Math.round(curChatter.settings.pitch*100) / 100).toFixed(2)}}</div>Pitch</template>
						<b-form-input type="range" min="0.0" max="1.0" step="0.01" v-model="curChatter.settings.pitch" @dblclick="curChatter.settings.pitch = 0.5"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Rate">
						<template slot="label"><div class="float-right">{{(Math.round(curChatter.settings.rate*100) / 100).toFixed(2)}}</div>Rate</template>
						<b-form-input type="range" min="0.0" max="1.0" step="0.01" v-model="curChatter.settings.rate" @dblclick="curChatter.settings.rate = 0.5"></b-form-input>
					</b-form-group>
				</b-col>
			</b-form-row>
			<b-form-group label="Instrument">
				<b-form-input v-model="curChatter.settings.instrument"></b-form-input>
			</b-form-group>
		</b-form>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{ ok, cancel }">
			<b-spinner v-show="loading>0" small label="Spinning"></b-spinner>
			<b-button size="sm" variant="success" type="submit" form="userChatterEditForm">
				Save
			</b-button>
			<b-button size="sm" @click="cancel()">
				Cancel
			</b-button>
		</template>
	</b-modal>
</template>

<style>
	.vbt-autocomplete-list {
		z-index:  1055;
	}
</style>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import debounce from 'debounce';

export default {
	name: 'ChatterEditModal',
	components: {
		VueTypeaheadBootstrap
	},
	data() { return {
		loading: 0,
		error: null,
		curChatter: {},
		voiceSuggestions: [],
	}},
	methods: {
		load(promise) {
			this.loading++;
			promise.catch(err => {
				this.error = err&&err.error||err.toString();
			}).finally(() => {
				this.loading--;
			});
			return promise;
		},
		show(serviceId, chatterToken) {
			this.error = null;
			this.curChatter = null;
			this.load(this.$api.get(`chatter/${encodeURIComponent(serviceId)}/${encodeURIComponent(chatterToken)}`)).then(chatter => {
				chatter.settings = chatter.settings || {};
				if(!('rate' in chatter.settings)) chatter.settings.rate = 0.5;
				if(!('pitch' in chatter.settings)) chatter.settings.pitch = 0.5;
				this.curChatter = chatter
			});

			this.$refs.modal.show();
		},
		save() {
			let data = {
				tts_status: this.curChatter.tts_status,
				voice_provider: this.curChatter.voice_provider,
				voice_id: this.curChatter.voice_id,
				settings: {
					pitch: this.curChatter.settings.pitch,
					rate: this.curChatter.settings.rate,
					instrument: this.curChatter.settings.instrument,
				},
			};
			this.load(this.$api.post(`chatter/${encodeURIComponent(this.curChatter.service_id)}/${encodeURIComponent(this.curChatter.chatter_token)}`, data)).then(() => {
				this.$refs.modal.hide();
				this.$bvToast.toast('Successfully saved', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
				this.$emit('saved');
			});
		},
		voiceSearch: debounce(function() {
			if(!this.curChatter.voice_name || this.curChatter.voice_name == '') {
				this.curChatter.voice_provider = null;
				this.curChatter.voice_id = null;
				return;
			}
			this.loading++;
			this.$api.get('userVoices', {
				q: this.curChatter.voice_name,
				limit: 10
			}).then(results => {
				this.voiceSuggestions = results.results;
			}).catch(err => {
				this.channelSuggestions = [];
				this.error = err.error;
			}).finally(() => {
				this.loading--
			});
		}, 500),
		setVoice(item) {
			this.curChatter.voice_provider = item.provider;
			this.curChatter.voice_id = item.id;
		}
	}
};
</script>
